import PropTypes from 'prop-types';
import React from 'react';

const TextAreaCustomFieldValue = ({
  team,
  csrfToken,
  confirm,
  customFieldValue,
  customFieldValueChanged,
  idSuffix
}) => (
  <div className="row mt-3" style={{"padding": "10px 0 15px 0"}}>
    <div className="col-12">
      <div className="row">
        <div className="col-12">
          <p style={{
               "fontSize": "16px",
               "marginBottom": "12px"
             }}>
            <strong>{customFieldValue.custom_field.name}</strong>{!customFieldValue.custom_field.required ? " (optional)" : null}
          </p>
          {customFieldValue.custom_field.help_text ? (
            <p className="small mb-2" style={{ color: 'var(--sl-text-tertiary)', marginTop: '-8px' }}>
              {customFieldValue.custom_field.help_text}
            </p>
          ) : null}
        </div>
      </div>
      <div className="form-row">
        <div className="col-12">
          <div className="form-group">
            <textarea className="form-control"
                      style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)", "fontSize": "14px", "resize": "none"}}
                      placeholder={customFieldValue.custom_field.name + (customFieldValue.custom_field.required ? " (required)" : " (optional)")}
                      id={idSuffix ? `custom-field-textarea-${customFieldValue.custom_field.id}-${idSuffix}` : "exampleFormControlTextarea1"}
                      maxLength={customFieldValue.custom_field.max_length || undefined}
                      value={customFieldValue.value || ""}
                      onChange={
                        (e) => {
                          var updated = Object.assign({}, customFieldValue, {value: e.target.value});
                          customFieldValueChanged(updated);
                        }
                      }
                      rows="3">
            </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
);

TextAreaCustomFieldValue.propTypes = {
  team: PropTypes.object,
  csrfToken: PropTypes.string,
  confirm: PropTypes.object,
  customFieldValue: PropTypes.object.isRequired,
  customFieldValueChanged: PropTypes.func.isRequired,
  idSuffix: PropTypes.string
};

TextAreaCustomFieldValue.defaultProps = {
  idSuffix: null
};

export default TextAreaCustomFieldValue;
